import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Store, ShoppingBasket, User, ShieldCheck, CalendarCheck } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import PickupPanel from "@/components/PickupPanel";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setOpen, count } = useCart();
  const { user } = useAuth();
  const [pickupOpen, setPickupOpen] = useState(false);

  const tabs = [
    { id: "nav-pickup", label: "Enlèvement", icon: Store, action: () => setPickupOpen(true) },
    { id: "nav-reserve", label: "Réserver", icon: CalendarCheck, path: "/reserver" },
    { id: "nav-order", label: "Ma commande", icon: ShoppingBasket, action: () => setOpen(true), badge: count },
    { id: "nav-profile", label: "Profil", icon: User, path: "/profil" },
  ];
  if (user?.role === "admin") {
    tabs.push({ id: "nav-admin", label: "Admin", icon: ShieldCheck, path: "/admin" });
  }

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 bg-[#FEF9F6] border-t border-[#6B1226]/8"
      data-testid="bottom-nav"
    >
      <div className="app-frame max-w-[520px] mx-auto" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className={`grid ${tabs.length === 5 ? "grid-cols-5" : "grid-cols-4"} pt-[3.6cqw] pb-[3cqw]`} style={{ paddingBottom: "calc(3cqw + env(safe-area-inset-bottom, 0px))" }}>
          {tabs.map((tab) => {
            const active = tab.path && location.pathname === tab.path;
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                data-testid={tab.id}
                onClick={() => (tab.action ? tab.action() : navigate(tab.path))}
                className={`relative flex flex-col items-center gap-[1.2cqw] transition-colors ${
                  active ? "text-[#6B1226]" : "text-[#1C1917] hover:text-[#6B1226]"
                }`}
              >
                <span className="relative">
                  <Icon strokeWidth={1.4} style={{ width: "6cqw", height: "6cqw" }} />
                  {tab.badge > 0 && (
                    <span
                      className="absolute rounded-full bg-[#6B1226] text-[#FAF6F0] font-bold flex items-center justify-center"
                      style={{
                        top: "-1.6cqw",
                        right: "-2.6cqw",
                        minWidth: "4.2cqw",
                        height: "4.2cqw",
                        fontSize: "2.6cqw",
                        padding: "0 1cqw",
                      }}
                      data-testid="nav-order-badge"
                    >
                      {tab.badge}
                    </span>
                  )}
                </span>
                <span className={`font-display leading-none whitespace-nowrap ${tabs.length === 5 ? "text-[3.2cqw]" : "text-[4cqw]"}`}>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
      <PickupPanel open={pickupOpen} onClose={() => setPickupOpen(false)} />
    </nav>
  );
}
